/**
 * Loại dữ liệu combobox bảng lương
 */
export default {
  All: 0,
  Allocation: 1, // Bảng lương đã phân bổ
};
